// import { useEffect } from "react";
// import { clearSession, getSession, isSessionExpired, updateLastActivity } from "../utils/session";
// const INACTIVITY_LIMIT_MS = 10 * 60 * 1000; // 10 minutes

// const AuthHandler = ({ setUser }) => {
//   useEffect(() => {    
//     console.log("AuthHandler: Running useEffect");
//     const token = localStorage.getItem("token");

//     setUser((prevUser) => {
//       if (prevUser === !!token) {
//         return prevUser; // ✅ Prevent unnecessary updates
//       }
//       console.log("AuthHandler: Updating user state");
//       return !!token; // ✅ Store boolean instead of object
//     });
//   }, []); // ✅ Runs only once

//   return null; // ✅ No extra re-renders
// };

// export default AuthHandler;
// src/components/AuthHandler.js
// src/components/AuthHandler.js

// import { useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { clearSession, getSession, isSessionExpired, updateLastActivity } from "../src/utils/Session";
// const INACTIVITY_LIMIT_MS = 5 * 60 * 1000; // 10 minutes

// const AuthHandler = ({ setUser }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const handleActivity = () => updateLastActivity();

//     const interval = setInterval(() => {
//       const session = getSession();
//       if (!session || isSessionExpired(session)) {
//         clearSession();
//         setUser(false);
//         navigate("/", { replace: true });
//       }
//     }, 60000); // check every 60 seconds

//     window.addEventListener("mousemove", handleActivity);
//     window.addEventListener("keydown", handleActivity);

//     return () => {
//       clearInterval(interval);
//       window.removeEventListener("mousemove", handleActivity);
//       window.removeEventListener("keydown", handleActivity);
//     };
//   }, [setUser, navigate]);

//   useEffect(() => {
//     updateLastActivity();
//   }, [location]);

//   return null;
// };

// export default AuthHandler;
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  clearSession,
  getSession,
  isSessionExpired,
  updateLastActivity,
} from "../src/utils/Session";

const INACTIVITY_LIMIT_MS = 5 * 60 * 1000;

const AuthHandler = ({ setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const publicRoutes = [
      "/",
      "/OrgProfileForm",
      "/forgot-password",
      "/reset-password",
    ];

    const handleActivity = () => updateLastActivity();

    const interval = setInterval(() => {
      // ✅ Skip auth check for public routes
      if (publicRoutes.includes(location.pathname)) return;

      const session = getSession();

      if (!session || isSessionExpired(session)) {
        clearSession();
        setUser(false);
        navigate("/", { replace: true });
      }
    }, 60000);

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);

    return () => {
      clearInterval(interval);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
    };
  }, [setUser, navigate, location.pathname]);

  useEffect(() => {
    updateLastActivity();
  }, [location]);

  return null;
};

export default AuthHandler;
